import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { LoadableDataState, showMessage } from "@my-dld/utils/UIUtils";
import { EjariContractContext, updateContractContext } from "@eres/ejari-core/contexts/EjariContractContext";
import Strings from "@my-dld/assets/strings";
import FormSection from "@my-dld/components/Form/FormSection";
import FormAction from "@my-dld/components/Form/FormAction";
import FormRow from "@eres/forms-web/FormRow";
import { navigate } from "@my-dld/utils/StoreUtils";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { defaultErrorManager } from "@eres/forms/errormanager";
import DateInputField from "@eres/forms-web/DateInputField";
import { serverDateConverter } from "@my-dld/utils/LookupUtil";
import TextInputField from "@eres/forms-web/TextInputField";
import _ from "lodash";
import { checkNonEmpty } from "../../utils";
import { MoveOut, ValidateDewaMoveOut } from "@eres/ejari-api/Entity/contract";
import { EjariPropertyType, EjariPropertyUsage } from "@eres/ejari-api/Entity";
import { getTenantData } from "@eres/ejari-core/Utils";
import { EjariApi } from "@eres/ejari-api";

interface Props extends RoutedViewProps {
}

export interface MoveOutState extends LoadableDataState, MoveOut {
	isValid: boolean;
}

class MoveOutInfo extends Component<Props, MoveOutState> {
	static contextType = EjariContractContext;
	context!: React.ContextType<typeof EjariContractContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			errorContainer: {},
			loadState: "done",
			isValid: false,
		};
	}

	componentDidMount() {
		let ctx = this.context;
		const contractData = ctx.finance;
		const moveOut = ctx.moveOut;
		if ( contractData ) {
			this.setState( {
				DewaMoveinDate: contractData.StartDate,
				DewaMoveoutDate: moveOut ? moveOut.DewaMoveoutDate : undefined,
				DewaMoveoutcontractNumber: moveOut ? moveOut.DewaMoveoutcontractNumber : undefined,
			} );
		}
	}

	componentDidUpdate( prevProps: Readonly<Props>, prevState: Readonly<MoveOutState>, snapshot?: any ) {
		if ( !_.isEqual( prevState, this.state ) )
			this.updateValidity();
	}

	render() {
		const { isValid } = this.state;
		return <>
			<RenderDewaMoveTo state={ this.state } holder={ this } onSkip={ this.onSkip }/>
			<FormRow>
				<FormAction
					disablePrimaryAction={ !isValid }
					groupClassName={ "text-center" }
					primaryActionLabel={ Strings.continue }
					onPrimaryAction={ this.onContinue }
					secondaryActionLabel={ Strings.back }
					onSecondaryAction={ this.onBack }/>
			</FormRow>
		</>;
	}

	getUpdatedData = ( state: MoveOutState = this.state ) => {
		const data: MoveOut = _.pick( state, "DewaMoveinDate", "DewaMoveoutDate", "DewaMoveoutcontractNumber" );
		return data;
	};

	updateValidity = () => {
		const state = this.state;
		let isValid: boolean = true;
		let errorContainer: {} = [];
		isValid = checkNonEmpty( state, "DewaMoveinDate", errorContainer ) && isValid;
		isValid = checkNonEmpty( state, "DewaMoveoutDate", errorContainer ) && isValid;
		isValid = checkNonEmpty( state, "DewaMoveoutcontractNumber", errorContainer ) && isValid;
		this.setState( {
			isValid: isValid,
		} );
	};

	private onSkip = () => {
		updateContractContext( { moveOut: undefined } );
		if ( this.context.property?.EjariPropertyUsageId === EjariPropertyUsage.INDUSTRIAL ) {
			navigate( "hazards" );
		} else {
			navigate( "payment" );
		}
	};

	private onContinue = () => {
		const ctx = this.context;
		const contractData = ctx.finance;
		if ( contractData ) {
			this.setState( { loadState: "loading" } );
			let data: MoveOut = {
				...this.getUpdatedData(),
			};
			let eprop = ctx.property!;
			let epid = eprop.PropertyTypeId === EjariPropertyType.UNIT ? eprop.UnitEjariPropertyId : eprop.VillaEjariPropertyId;
			let m: ValidateDewaMoveOut = {
				...data,
				DewaMoveoutRequestno: this.state.DewaMoveoutcontractNumber,
				ContractStartDate: contractData.StartDate!,
				ContractEndDate: contractData.EndDate!,
				EjariPropertyId: [
					Number( epid ),
				],
				...getTenantData( ctx ),
			};
			EjariApi.validateDewaMoveOut( m ).then( rs => {
				this.setState( { loadState: "done" } );
				updateContractContext( {
					moveOut: data,
				} );
				if ( ctx.property?.EjariPropertyUsageId === EjariPropertyUsage.INDUSTRIAL ) {
					navigate( "hazards" );
				} else {
					navigate( "payment" );
				}
			} ).catch( ex => {
				this.setState( { loadState: "done" } );
				showMessage( ex.toString() );
			} );
		} else {
			this.onBack();
		}
	};

	private onBack = () => {
		this.props.history.goBack();
	};

}

export default MoveOutInfo;

export function RenderDewaMoveTo( props: {
	state: MoveOutState,
	holder: Component,
	onSkip: () => void
} ) {
	const { state, holder, onSkip } = props;
	const { loadState } = state;
	const filedProps: Partial<WebFormFieldProps<any, any>> = {
		holder: StateHolder.buildStateHolder( holder ),
		containerClassName: "col-md-4 form-group",
		errorManager: defaultErrorManager,
	};
	return <FormSection
		title={ Strings.move_out_information }
		action={ <button
			className={ "btn btn_1 btn_style1" }
			onClick={ onSkip } type="button">
			{ Strings.skip }
		</button> }>
		{ loadState === "loading" && <span className="spinner-border"/> }
		<FormRow { ...filedProps }>
			<DateInputField
				required={ true }
				label={ Strings.move_in_date }
				id={ "DewaMoveinDate" }
				disabled={ true }
				valueConverter={ serverDateConverter }
			/>
			<DateInputField
				required={ true }
				label={ Strings.move_out_date }
				id={ "DewaMoveoutDate" }
				valueConverter={ serverDateConverter }
				extraOpts={ {
					maxDate: state.DewaMoveinDate?.asDate()
				} }
			/>
		</FormRow>
		<FormRow { ...filedProps }>
			<TextInputField
				required={ true }
				containerClassName={ "col-md-8" }
				id={ "DewaMoveoutcontractNumber" }
				label={ Strings.move_out_ejari_contract_number }
			/>
		</FormRow>
	</FormSection>;
}
